export default __webpack_public_path__ + "locales/it/FormGallery.json?hash=449288f074a907ec76946ca91cb689e2";